import _ from 'lodash'
import Mustache from 'mustache'

import riderMessages from 'core/data-model/constants/validation-messages'
import { formatNumber } from 'core/service/lib/number-format'

export const checkRiderSumAssuredRule = (rule, eligibilities) => {
  let errorMessage = ''

  if (eligibilities.rider.sumAssured < rule.minimumValue || eligibilities.rider.sumAssured > rule.maximumValue) {
    let messageId = `RULE_RIDER_${eligibilities.rider.code}_SUM_ASSURED`
    const riderMsg =
      eligibilities.rider.code === 'CIES'
        ? Mustache.render(riderMessages.RULE_RIDER_CIES_SUM_ASSURED, { minSumAssured: formatNumber(rule.minimumValue) })
        : _.get(riderMessages, messageId)

    errorMessage = riderMsg || riderMessages.RULE_MESSAGE_NOT_FOUND
  }

  return {
    type: rule.validationType,
    message: errorMessage,
  }
}
